<template>
    <div>
        <WelcomeBlock
            v-if="isWelcomeBlock"
            @open-appointment="showAppointmentBlock"
        />
        <AppointmentBlock
            :user-id="userInfo.id"
           v-else
        />
    </div>

</template>

<script>



import AppointmentBlock from "./Status/AppointmentBlock.vue";
import WelcomeBlock from "./Status/WelcomeBlock.vue";

export default {
    name: 'EmployeeStatus',
    components: {WelcomeBlock, AppointmentBlock},
    props: {
        userInfo: {
            type: Object
        },
    },
    data() {
        return {
            isWelcomeBlock: true,
        }
    },
    methods: {
        showAppointmentBlock(result) {
            this.isWelcomeBlock = !result
        },
    }


}

</script>

<style scoped>


</style>
